import React, { useState } from "react";
import "./style.scss";
import { TextField } from "@material-ui/core";
import { Button } from "../../../components";
import { LoaderBlue, logoBapenda } from "../../../assets";
import BaseURL from "../../../assets/utils/baseUrl";
import { useNavigate } from "react-router-dom";

function Login({ setToken }) {
  const [username, setUserName] = useState("");
  const [password, setPassword] = useState("");
  const [modal, setModal] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!username || !password) {
      alert("Harap isi semua field");
      return;
    }

    setModal(true);

  try {
  const data = new FormData();
  data.append("username", username);
  data.append("password", password);

const response = await fetch(BaseURL + "index.php/api/Login", {
  method: "POST",
  body: data,
});

  const result = await response.json();
  setModal(false);

  if (result.status) {
    const token = result.token;

    // simpan token
    localStorage.setItem("token", token);

    setToken({ token });

    // 🔥 REDIRECT KE DASHBOARD
    navigate("/admin/dashboard");

  } else {
    alert("Login gagal");
  }
} catch (error) {
  setModal(false);
  console.log(error);
  alert("Terjadi kesalahan");
}
  };

  return (
    <div className="auth-page">
      <img src={logoBapenda} style={{ width: 200 }} alt="logo" />

      <div className="auth-card">
        <p className="form-label">Login</p>

        <form onSubmit={handleSubmit}>
          <TextField
            label="Username"
            fullWidth
            value={username}
            onChange={(e) => setUserName(e.target.value)}
          />

          <TextField
            type="password"
            label="Password"
            fullWidth
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />

          <button
  type="submit"
  style={{
    width: "100%",
    padding: "12px",
    marginTop: "15px",
    backgroundColor: "#1976d2",
    color: "#fff",
    border: "none",
    borderRadius: "8px",
    fontSize: "16px",
    fontWeight: "bold",
    cursor: "pointer",
    transition: "0.3s"
  }}
  onMouseOver={(e) => (e.target.style.backgroundColor = "#125ea2")}
  onMouseOut={(e) => (e.target.style.backgroundColor = "#1976d2")}
>
  Login
</button>
        </form>
      </div>

      {modal && (
        <div className="darker-bg-admin">
          <img src={LoaderBlue} style={{ width: 50 }} alt="loading" />
        </div>
      )}
    </div>
  );
}

export default Login;